<script setup lang="ts">
  import { type IconValues } from '@gat-ship/icons'
  import * as icons from 'lucide-vue-next'
  import { computed, h, type HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'

  export interface GatIconProps {
    icon: IconValues
    strokeWidth?: number
    disabled?: boolean
    loading?: boolean
    class?: HTMLAttributes['class']
  }

  const props = withDefaults(defineProps<GatIconProps>(), {
    strokeWidth: 2
  })

  const icon = computed(() => {
    if (props.loading) {
      return icons.Loader2
    }
    const icon = props.icon as string
    if (icon === 'blank') {
      return h('i')
    }
    const lucide: any = icons
    return lucide[icon]
  })
</script>
<template>
  <component
    :is="icon"
    :stroke-width="strokeWidth"
    :class="
      cn(props.class, 'lucide-icon shrink-0', {
        'opacity-50': disabled,
        'animate-spin': loading
      })
    "
    :absolute-stroke-width="true"
  />
</template>
